<template>
    <div class="home-content">
      <!-- 商机 -->
      <div class="home-t">
        <div class="home-l">
          <div class="news-details" v-if="newInfo">
            <h3 class="news-details-title">{{newInfo.title}}</h3>
            <div class="news-details-des">
              <span>Time：{{$service.SmarDateEn(new Date(newInfo.inTime))}}</span>
              <!-- <span>浏览量：568</span> -->
            </div>
            <!-- <div v-if="genre" style="word-break:break-all;" v-html="newInfo.summary"></div> -->
            <div v-if="JSON.parse(newInfo.introduction)" v-html="JSON.parse(newInfo.introduction)"></div>
          </div>
        </div>
        <div class="home-r">
          <newsList :hotNewList="hotNewList"></newsList>
        </div>
      </div>
    </div>
</template>

<script>
import newsList from "./news-list";
import { mapActions, mapGetters } from "vuex";


export default {
  name: "news",
  data() {
    return {
      hotNewList:[],
      newInfo: null
    };
  },
  components: {
    newsList,
  },
  watch: {
    $route(val, oldVal) {
      if (this.genre) {
        this.init2();
      } else {
        this.init();
      }
    }
  },
  computed: {
    newId() {
      return this.$route.query.id;
    },
    genre() {
      return this.$route.query.genre;
    }
  },
  async created() {
    if (this.genre) {
      this.init2();
      this.getData2();
    } else {
      this.init();
      this.getData();
    }
  },
  methods: {
    ...mapActions({
      getExNews: "getExNews",
      getNewsById: "getNewsById",
      getHostNews: "getHostNews",
      getHostNewsById: "getHostNewsById"
    }),
    async getData() {
      let list = await this.getExNews(
        {
          "pageSize": 5, // 前5条
          "pageIndex": this.PageIndex,
        }
      );
      this.hotNewList = list.items;
    },
    async getData2() {
      let list = await this.getHostNews(
        {
          "pageSize": 5, // 前5条
          "pageIndex": this.PageIndex,
        }
      );
      this.hotNewList = list.items;
    },
    async init() {
      let info = await this.getNewsById(this.newId);
      this.newInfo = info;
      // console.log("资讯详情：",this.newInfo);
    },
    async init2() {
      let info = await this.getHostNewsById(this.newId);
      this.newInfo = info;
      if (this.newInfo.summary) {
        this.newInfo.summary = this.enter(this.newInfo.summary);
      }
      // console.log("资讯详情：",this.newInfo);
    },
    enter(str){
      let str1=str.replace(/\n/g,"<br/>");
      return str1;
    },
  },
};
</script>

<style scoped lang='scss'>
.home-content{
    margin-top: 20px;
    width: 1200px;
    margin: 0 auto 60px;
    .home-t{
        &::after {
          content: "";
          clear: left;
          display: block;
        }
    }
    .home-l{
        margin-right: 20px;
        width: 880px;
        padding: 30px 60px 50px;
        background: #fff;
        float: left;
        .news-details {
          width: 100%;
          &-title {
            font-size: 30px;
            color: #333;
            line-height: 1;
            margin-bottom: 30px;
          }
          &-des {
            padding-bottom: 20px;
            border-bottom: 1px solid #d9d9d9;
            margin-bottom: 40px;
            span {
              font-size: 14px;
              color: #666;
              line-height: 1;
            }
          }
        }
    }
    .home-r{
        float: left;
        width: 300px;
    }
}
  ::v-deep .news-details {
  /* table 样式 */
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }

  /* blockquote 样式 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  pre code {
    display: block;
  }

  /* ul ol 样式 */
  ul, ol {
    margin: 10px 0 10px 20px;
  }
}
</style>